import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from '../button/button.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
    imports: [CommonModule, TranslatePipe, TranslateDirective, DragDropModule, ButtonModule],
    declarations: [ConfirmDialogComponent],
    exports: [ConfirmDialogComponent]
})
export class ConfirmDialogModule {}
